import styled from "styled-components";
import breakpoints from "../assets/styles/breakpoint";

export const LargeHeadline = styled.h1`
  font-family: "NunitoSans";
  font-weight: 700;
  font-size: 34px;
  letter-spacing: 0.5px;

  ${breakpoints.md} {
    font-size: 34px;
  }

  ${breakpoints.sm} {
    font-size: 28px;
  }
`;

export const SubHeadline = styled.p`
  font-family: "NunitoSans";
  font-weight: 700;
  font-size: 26px;
  line-height: 30px;
  letter-spacing: 0.5px;

  ${breakpoints.md} {
    font-size: 24px;
  }

  ${breakpoints.sm} {
    font-size: 20px;
  }
`;

export const CaptionText = styled.p`
  font-family: "NunitoSans";
  font-weight: 650;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.2px;

  ${breakpoints.md} {
    font-size: 20px;
  }

  ${breakpoints.sm} {
    font-size: 18px;
  }
`;

export const LittleHeadline = styled.p`
  font-family: "NunitoSans";
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.2px;

  ${breakpoints.md} {
    font-size: 14px;
  }
`;

export const LittleText = styled.p`
  font-family: "NunitoSans";
  font-weight: 550;
  font-size: 14px;
  letter-spacing: 0.2px;

  ${breakpoints.md} {
    font-size: 12px;
  }
`;

export const LittleSubHeadline = styled.p`
  font-family: "NunitoSans";
  font-weight: 550;
  font-size: 16px;
  letter-spacing: 0.2px;

  ${breakpoints.md} {
    font-size: 14px;
  }
`;

export const LabelText = styled.p`
  font-family: "NunitoSans";
  font-weight: 650;
  font-size: 18px;
  letter-spacing: 0.2px;

  ${breakpoints.md} {
    font-size: 16px;
  }

  ${breakpoints.xs} {
    font-size: 14px;
  }
`;

export const SubTitle = styled.p`
  font-family: "NunitoSans";
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1px;

  ${breakpoints.md} {
    font-size: 18px;
  }

  ${breakpoints.sm} {
    font-size: 16px;
  }
`;

export const TextBody = styled.p`
  font-family: "NunitoSans";
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.2px;

  ${breakpoints.md} {
    font-size: 16px;
  }

  ${breakpoints.sm} {
    font-size: 16px;
  }
`;

export const MediumText = styled.p`
  font-family: "NunitoSans";
  font-weight: 600;
  font-size: 17px;
  line-height: 26px;
  letter-spacing: 0.4px;

  ${breakpoints.sm} {
    font-size: 16px;
  }
`;

export const NotificationText = styled.p`
  font-family: "NunitoSans";
  font-weight: 400;
  font-size: 15px;
  letter-spacing: 0.4px;

  ${breakpoints.md} {
    font-size: 13px;
  }
`;

export const BoldTextBody = styled.p`
  font-family: "NunitoSans";
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.4px;

  ${breakpoints.md} {
    font-size: 13px;
  }
`;

export const SuperBigHeadline = styled.h1`
  font-family: "NunitoSans";
  font-weight: 700;
  font-size: 110px;
  line-height: 120px;
  letter-spacing: 0.5px;

  ${breakpoints.md} {
    font-size: 95px;
    line-height: 102px;
  }

  ${breakpoints.sm} {
    font-size: 70px;
    line-height: 78px;
  }
`;

